import React, { Component } from "react";
import TextField from "./TextField";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import { InputAdornment } from "@mui/material";
import { Close } from "@mui/icons-material";

const ranges = {
  Today: [moment().startOf("day"), moment().endOf("day")],
  Yesterday: [
    moment().subtract(1, "days").startOf("day"),
    moment().subtract(1, "days").endOf("day"),
  ],
  "Last 7 Days": [
    moment().subtract(6, "days").startOf("day"),
    moment().endOf("day"),
  ],
  "Last 30 Days": [
    moment().subtract(29, "days").startOf("day"),
    moment().endOf("day"),
  ],
  "This Month": [
    moment().startOf("month").startOf("day"),
    moment().endOf("month").endOf("day"),
  ],
  "Last Month": [
    moment().subtract(1, "month").startOf("month").startOf("day"),
    moment().subtract(1, "month").endOf("month").endOf("day"),
  ],
};
class CustomDateRangePicker extends Component {
  handleRemoveDate = () => {
    if (this.props.handleRemoveDate) {
      this.props.handleRemoveDate();
    }
  };
  render() {
    return (
      <DateRangePicker
        containerStyles={{}}
        {...this.props}
        ranges={ranges}
        timePicker
        timePicker24Hour
      >
        {
          this.props.actionLogs?
          <TextField
          fullWidth
          rows
          label={this.props.label || "Select Date"}
          value={this.props.selectedDate||""}
          sx={{
            '& .MuiOutlinedInput-input': {
              color:this.props.color||'',
            }
          }}
          InputProps={{
            endAdornment: !this.props.isButtonDisabled && (
              <InputAdornment position="end" disableTypography style={{ color: "gray" }}>
                <span
                  style={{
                    color: "gray",
                    marginTop: "0.5rem",
                    cursor: "pointer"
                  }}
                  onClick={this.handleRemoveDate}
                >
                  <Close />
                </span>
              </InputAdornment>
            )
          }}
          />
          :
          <TextField
          fullWidth
          label={this.props.label || "Select Date"}
          value={this.props.selectedDate||""}
        />
        }
      </DateRangePicker>
    );
  }
}

export default CustomDateRangePicker;
